import { Col, Pagination, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import './style.css'
import Tabs from '../../../../components/Tabs';
import JobCard from './JobCard';
import useJobApi from '../../../../config/hooks/api/booking/job/useJobApi';
import { useDispatch, useSelector } from 'react-redux';
import { setAppLoading } from '../../../../store/common/generalSlice';
import { bookingStatusTabs } from '../../../../config/utils/constants';
import { useLocation } from 'react-router-dom';

const MyJobsList = () => {
    const selectedBookingListStatus = useSelector(state => state?.booking?.selectedBookingListStatus) 
    const [menuItems, setMenuItems] = useState(bookingStatusTabs)
    const location = useLocation()
    
    useEffect(() => {
        console.log(menuItems,"menuItems");
        
        const hasContent = menuItems.some(e => e.content)
        if(!hasContent){
            const updatedTabArray = menuItems.map(item => ({    
                ...item,
                content: <TabContent key={item.id} jobStatus={item.status} locationKey={location.key} />
            }));
            setMenuItems(updatedTabArray)
        } else {
            // Re-inject location key so TabContent re-fetches on navigation back
            const updatedTabArray = menuItems.map(item => ({
                ...item,
                content: <TabContent key={item.id} jobStatus={item.status} locationKey={location.key} />
            }));
            setMenuItems(updatedTabArray)
        }
    }, [location.key])

    return (
        <Tabs
            defaultActiveKey="1"
            selectedTab={selectedBookingListStatus}
            data={menuItems}
            className='tabs'
        />
    )
}

export default MyJobsList



const TabContent = (props) => {
    const dispatch = useDispatch()

    const { getProviderJobsRequests } = useJobApi()

    const [selectedJobs, setSelectedJobs] = useState([])
    const [offset, setOffset] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0)


    
    const getMyJobsList = async (jobStatus) => {
        try {
            dispatch(setAppLoading(true))

            const response = await getProviderJobsRequests(pageSize, offset, jobStatus > -1 ? jobStatus : '') //default limit, offset,
            if (response) {
                setSelectedJobs(response?.data?.requests?.rows)

                setTotalItems(response?.data?.requests?.count)
                setOffset(offset + pageSize)

                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const onShowSizeChange = (current, pageSize) => {
        setPageSize(pageSize)
    };

    const onPageChange = (page) => {
        setCurrentPage(page);
        setOffset((page - 1) * pageSize)
    };

    useEffect(() => {
        console.log(props,"dddddddddddsdsdsd");
        
        getMyJobsList(props?.jobStatus)
    }, [props?.jobStatus, currentPage, pageSize, props?.locationKey])


    return (
        <Row className='md:mb-4 sm:mb-4 mb-6 w-full'>
            {selectedJobs && selectedJobs.length ? selectedJobs.map((job, index) => (
                <Col xl={8} sm={12} xs={24} className='cursor-pointer' key={'sj'+index}>
                    <JobCard jobData={job} key={index} />
                </Col>
            )) : ''}
            <Col span={24}>
                <div className='px-2 py-4 bg-white rounded-md'>
                    <Pagination
                        defaultPageSize={5}
                        showSizeChanger
                        onShowSizeChange={onShowSizeChange}
                        current={currentPage}
                        total={totalItems}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 20, 50]}
                        onChange={onPageChange}
                    />
                </div>
            </Col>
        </Row>
    )
}


